/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Barcode = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2 22L2.00001 2L8 2V3.5L3.50001 3.5L3.5 20.5H8V22H2Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22 2L22 22H16V20.5H20.5L20.5 3.5L16 3.5V2L22 2Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7 18L7 6L8.5 6L8.5 18H7Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10 18V6L11.5 6V18H10Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13 18L13 6L14.5 6L14.5 18H13Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16 18L16 6L17.5 6L17.5 18H16Z"
                        fill={color}
                    />
                </svg>
        );
    };
